//Auth API ENDPOINTS
export const USER_LOGIN = "admin/login";
export const REFRESH = "/api/v1/admin/refresh";

export const HEALTH_CHECK = "/api/v1/health"

//sam watch / theme ENDPOINT deprecated 
export const GET_SAM_SWITCH =
  ":type/switch?os=:os&limit=:limit&page=:page&name_sku=:name_sku&event=:event";

// TODO - 기능점검 후 프론트 코드를 리팩토링 할 경우 endpoint도 변경해야함
export const GET_SAM_SWITCH_V2 =
  "/api/v1/watch?os=:os&limit=:limit&page=:page&type=:type";

export const GET_ADMIN_SAM_SWITCH =
  "/api/v1/admin/watch?os=:os&limit=:limit&page=:page&search=:search&type=:type";

export const GET_SAM_THEME =
  "/api/v1/theme?os=:os&limit=:limit&page=:page&search=:search&type=:type"

export const OS_TYPE = {
  WEAR: "wear",
  TIZEN: "tizen",
}
export const SAMSWITCH_TYPE = {
  ALL: "all",
  WATCH: "watch",
  THEME: "theme",
  STUDIO: "studio",
}

export const WATCH_TYPE = {
  WATCH: "watch",
  SAM_WATCH: "samwatch",
  YAM_WATCH: "yamwatch",
}

export const ITEM_TYPE = {
  SAM_WATCH: "samwatch",
  YAM_WATCH: "yamwatch",
}

export const CREATE_SAM_SWITCH = "/api/v1/switch";
export const UPDATE_SAM_WATCH = "/api/v1/watch/:id";
export const GET_WATCH_ONE = "/api/v1/watch/:sku?type=:type"
export const DELETE_WATCH = "/api/v1/watch/:id?type=:type";
export const GET_THEME_ONE = "/api/v1/theme/:sku"
export const UPDATE_SAM_THEME = "/api/v1/theme/:id";
export const AUTOREMOVE_SAM_SWITCH = "switch/autoremove?auto_remove=:auto_remove&sku=:sku"
export const SAM_SWITCH_MANANGE = "switch/coupon_enabled?coupon_enabled=:coupon_enabled&type=:type&sku=:sku"
export const SAM_WATCH_MANANGE = "api/v1/watch/coupon_enabled?coupon_enabled=:coupon_enabled&type=:type&sku=:sku&item_type=:item_type"

export const GET_STUDIO = "/api/v1/studio?limit=:limit&page=:page&name=:name";
export const CREATE_SAM_STUDIO = "studio";
export const UPDATE_SAM_STUDIO = "studio/:id";

export const GET_COUPONS =
  "coupon?os=:os&limit=:limit&page=:page&name_sku=:name_sku&expired_date=:date";
export const CREATE_COUPONS = "coupon";
export const CREATE_COUPONS_V2 = "/api/v1/coupon";
export const DELETE_COUPON = "/api/v1/coupon/:sku?type=:type"

export const REDEEMED = "/api/v1/redeemed?sku=:sku&type=:type";
// export const REDEEMED_V2 = "redeemed/v2?sku=:sku";
export const POST_FLOATING_MENU = "switch/floating-menu"

export const SET_DISCOUNT = "/api/v1/discount/:type"
export const DISABLE_DISCOUNT = "/api/v1/discount/:type?sku=:sku"
export const UPDATE_BANNER = "banner/:sku"
export const GET_BANNER = "/api/v1/banner"
export const DELETE_BANNER = "banner?sku=:sku"